/** Provides a context-based wrapper for task mutation operations like adding or completing tasks. */
// @ts-check
import useTaskMutations from '@/features/tasks/hooks/mutations/use-task-actions.js';
import { TaskMutationsContext } from './useTaskMutationsContext.js';
import { useFocusContext } from './FocusContextExport.js';

export const TaskMutationsProvider = ({ children }) => {
  const { startFocus } = useFocusContext();
  const mutations = useTaskMutations({ startFocus });

  return (
    <TaskMutationsContext.Provider value={mutations}>
      {children}
    </TaskMutationsContext.Provider>
  );
};
